import { render } from "./ItemSettingBranchForm.vue?vue&type=template&id=ee1884aa"
import script from "./ItemSettingBranchForm.vue?vue&type=script&lang=js"
export * from "./ItemSettingBranchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__